<template>
  <div>
    <Tool>
      <template v-slot:title>
        <h1 class="tool-title-h1">
          角色管理
        </h1>
      </template>
      <template v-slot:content>
        <a-icon type="search" style="color: white; font-size: 20px"/>
        <a-input placeholder="查询编号,名称..."
                 style="width: 250px; background-color: transparent; color: white; border: none">
        </a-input>
      </template>
    </Tool>

    <div class="content">
      <div style="margin-bottom: 16px; display: flex; align-items: center;">
        <a-button type="primary" icon="plus-circle" ghost @click="handleAdd">新增</a-button>
      </div>
      <a-table
          rowKey="id"
          :columns="columns"
          :data-source="dataSource"
          :pagination="pagination"
          :loading="loading"
          bordered
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          @change="handleTableChange">

        <template slot="action" slot-scope="text, record">

          <a @click="handlePermission(record)">授权</a>
          <a-divider type="vertical"/>

          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">

              <a-menu-item>
                <a @click="handleEdit(record)">编辑</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>

            </a-menu>
          </a-dropdown>

        </template>


      </a-table>
    </div>

    <role-create-modal ref="roleCreateModal" @ok="loadData"></role-create-modal>

    <RolePermissionModal ref="rolePermissionModal" @ok="loadData"></RolePermissionModal>

  </div>
</template>

<script>

import Tool from '@/components/Tool.vue'
import {TableMixins} from '@/mixins/table-mixins';
import RoleCreateModal from "../components/setting/RoleCreateModal";
import RolePermissionModal from "../components/setting/RolePermissionModal";
import {HttpMixins} from "@/mixins/http-mixins";

export default {
  name: "Role",
  components: {
    RolePermissionModal,
    RoleCreateModal,
    Tool
  },
  mixins: [HttpMixins, TableMixins],
  data() {
    return {
      columns: [
        {
          title: '角色名称',
          align: "center",
          dataIndex: 'name',
        },
        {
          title: '描述',
          align: "center",
          dataIndex: 'description',

        },
        {
          title: '标记',
          align: "center",
          dataIndex: 'authority',
        },
        {
          title: '创建时间',
          align: "center",
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {customRender: 'action'},
          align: "center",
        }
      ],
      url: {
        list: window._CONFIG['domainURL'] + "/role/list",
        delete: window._CONFIG['domainURL'] + "/role",
      }
    }
  },
  methods: {
    handleDelete(id) {
      let that = this;
      that.loading = true;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success(response.msg);
            that.loadData();
          } else {
            that.$message.error(response.msg);
          }
        }
        that.loading = false;
      };
      that.$axios.delete(that.url.delete + "?id=" + id, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess));
    },
    handleEdit(record) {
      this.$refs.roleCreateModal.edit(record);
    },
    handleAdd() {
      this.$refs.roleCreateModal.add();
    },

    handlePermission(record) {
      this.$refs.rolePermissionModal.show(record);
    }

  },
  created() {
    this.loadData();
  }
}
</script>

<style scoped>

</style>
